<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="商品属性组"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="125px"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="名称" prop="Name">
              <el-input
                v-model="data.Name"
                placeholder="请填写名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="编码" prop="SpecCode">
              <el-input
                v-model="data.SpecCode"
                placeholder="请填写编码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  mounted() {},
  data() {
    return {
      data: {
        RecordId: 0,
        Name: "",
        OrderId: 0,
        State: 1,
       SpecCode:""
      },
      list: [],      
      api: require("@/api/goods/spec").default,    
      isMB: this.$store.state.isMB,
      rules: {
        Name: [{ required: true, message: "名称不能为空" }],
        SpecCode: [{ required: true, message: "编码不能为空" }],

        OrderId: [{ required: true, message: "序号不能为空" }],
      },
     
    };
  },
  mounted() {
   
  },
  methods: {
    onCreateOpened(row) {
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(data) {
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));
    
      data = this.$commonJs.obj.removeNullKey(data); //这个的作用是移除里面的null字段，有些接口参数传null会报错。

      this.loading();
      this.api.save(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.arr2 = [];
    
    },
  },
};
</script>